import { FC, Fragment } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';

import type { PreferredContact } from 'src/models/resume/resumeCommon.types';
import type { Phone } from 'src/models/resumeCard';

import ContactsPhone from 'src/components/ResumeCard/Body/Contacts/Phone';

interface Props {
    phones: Array<Phone>;
    preferredPhone?: PreferredContact;
}

const ContactsOpen: FC<Props> = ({ phones, preferredPhone }) => {
    return (
        <>
            {phones.map((phone, index) => (
                <Fragment key={phone.type}>
                    {index !== 0 && <VSpacing default={8} />}
                    <ContactsPhone phone={phone} preferredPhone={preferredPhone} isOpenContacts />
                </Fragment>
            ))}
        </>
    );
};

export default ContactsOpen;
